import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=222e47ea&scoped=true&"
import script from "./Unit.vue?vue&type=script&lang=js&"
export * from "./Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222e47ea",
  null
  
)

export default component.exports